// extracted by mini-css-extract-plugin
export default {"formRow":"ForgotPassword_formRow__NsJN4","input":"ForgotPassword_input__SBJVU","buttonRow":"ForgotPassword_buttonRow__S0YRd"};